import { render, staticRenderFns } from "./RecibosTable.vue?vue&type=template&id=40a49759&scoped=true&lang=pug&"
import script from "./RecibosTable.vue?vue&type=script&lang=js&"
export * from "./RecibosTable.vue?vue&type=script&lang=js&"
import style0 from "./RecibosTable.vue?vue&type=style&index=0&id=40a49759&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a49759",
  null
  
)

export default component.exports